import { notNullish, parseString } from "@de-xima/xima-common-js-lang";
import $ from "jquery";

/**
 * Adds an event listener for copying text as plain text. Add the class
 * `copy-plain-text` to an element, and whenever the user copies text from that
 * element or some sub element, the entire plain text of the element with the
 * class will be copied instead.
 */
export function initCopyPlainText(): void {
  $(document).on("copy", ".copy-plain-text", (e) => {
    const event = e.originalEvent;
    const target = e.currentTarget as unknown;
    if (event instanceof ClipboardEvent && target instanceof HTMLElement && notNullish(event.clipboardData)) {
      const text = parseString($(target).text()).trim();
      event.preventDefault();
      event.clipboardData.setData("text/plain", text);
    }
  });
}
